import { render } from "./InputElement.vue?vue&type=template&id=545a927e"
import script from "./InputElement.vue?vue&type=script&lang=js"
export * from "./InputElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__